
const shopData = JSON.parse(document.querySelector('#bss-b2b-store-data').text);
const hrefArr = window.location.href.split("/");
const isProductPage = hrefArr[hrefArr.length - 2] === "products";
if (shopData.customer.id != null) {
  const btnCheckout = document.querySelector("button.add-to-cart");
  
  if (btnCheckout != null) {
    btnCheckout.style.display = "block";
  }
  if (isProductPage) {
    const navSite = document.querySelector(".site-nav .site-nav__icons");
    const newElement = document.createElement("div");
    newElement.classList.add('btn-show-price');
    navSite.insertBefore(newElement, navSite.firstChild);

    const prdPrice = document.querySelector(".product-single__meta .product-block .product__price");

    const priceOriginal = document.createElement("div");
    priceOriginal.style.display = "none";
    prdPrice.parentElement.insertBefore(priceOriginal, prdPrice.parentElement.firstChild);
      setTimeout(() => {
        priceOriginal.textContent = BSS_B2B && BSS_B2B.formatMoney(shopData.product.price);
      }, 2000);

    
    let count = 0;
    newElement.addEventListener('click', () => {
        // const priceOriginalEle = document.querySelector('.product-single__meta .bss-b2b-customized-compare-at-price');
        // const priceEle = document.querySelector('.product-single__meta [bss-b2b-product-price]');

        const priceOriginalEle = document.querySelector('.product-single__meta [bss-b2b-product-price] span:not([class])');
        const priceEle = document.querySelector('.product-single__meta [bss-b2b-product-price] span:nth-child(2)');
        const retailPrice = document.querySelector('.product-single__meta .product__price');
        count++;
        if (count > 3) {
          count = 1;
        }
        if (priceOriginalEle) {
          if (count == 1) {
            priceOriginalEle.style.setProperty('display', 'inline-block', 'important');
            priceOriginalEle.style.textDecoration = "unset";
            priceEle.style.setProperty('display', 'none', 'important');
            retailPrice.style.setProperty('display', 'block', 'important');
          } else if (count == 2) {
            priceOriginalEle.style.setProperty('display', 'none', 'important');
            priceEle.style.setProperty('display', 'inline-block', 'important');

          } else {
            priceOriginalEle.style.setProperty('display', 'none', 'important');
            priceEle.style.setProperty('display', 'none', 'important');

          }
        } else {
          if (count == 1) {
            priceEle.style.setProperty('display', 'block', 'important');

          } else if (count == 2) {
            priceEle.style.setProperty('display', 'block', 'important');

          } else {
            priceEle.style.setProperty('display', 'none', 'important');

          }
        }
        
    })

    const variantInputs = document.querySelectorAll(".variant-input input")
    variantInputs.forEach(function (input) {
      input.addEventListener("click", function () {
        prdPrice.classList.remove('active');
        setTimeout(() => {
          priceOriginal = prdPrice.querySelector('span').textContent
          priceOriginal.style.display = "block";
          if (count >= 3) {
            count = 0
          }
          if (count > 1) {
            count = 1
          }
        }, 1000)
      });
    });
  }

  // quick view
  const quickView = document.querySelectorAll('.quick-product__btn');
  if (quickView.length) {
    quickView.forEach((element) => {
      element.addEventListener('click', (e) => {
        const cardItem = e.target.closest('.grid__item.grid-product').querySelector('.modal .modal__inner')
        setTimeout(() => {
          const btnCheckout = cardItem.querySelector("button.add-to-cart");
          
          if (btnCheckout != null) {
            btnCheckout.style.display = "block";
          }
          if (isProductPage) {
            const navSite = document.querySelector(".site-nav .site-nav__icons");
            const newElement = document.createElement("div");
            newElement.classList.add('btn-show-price');
            navSite.insertBefore(newElement, navSite.firstChild);
    
            const prdPrice = document.querySelector(".product-single__meta .product-block .product__price");
            let priceOriginal = prdPrice.querySelector('span:first-child').textContent;
      
            const newElementPrice = document.createElement("div");
            newElementPrice.textContent = priceOriginal;
            prdPrice.insertBefore(newElementPrice, prdPrice.firstChild);
            
            let count = 0;
            newElement.onclick = function() {
              count++;
              if (count > 3) {
                count = 1;
              }
              if (count == 1) {
                prdPrice.classList.add('active');
                newElementPrice.textContent = priceOriginal;
              } else if (count == 2) {
                newElementPrice.textContent = prdPrice.querySelector('span:last-child').textContent;
              } else {
                prdPrice.classList.remove('active');
              }
            };
    
            const variantInputs = document.querySelectorAll(".variant-input input")
            variantInputs.forEach(function (input) {
              input.addEventListener("click", function () {
                newElementPrice.style.display = "none"
                setTimeout(() => {
                  priceOriginal = prdPrice.querySelector('span').textContent
                  newElementPrice.textContent = priceOriginal;
                  newElementPrice.style.display = "block"
                  if (count >= 3) {
                    count = 0
                  }
                  if (count > 1) {
                    count = 1
                  }
                }, 1000)
              });
            });
          }
        }, 2000)
      })
    })
  }
}
